import { GET_FORWARDER_ACCOUNT_BALANCE } from './actionTypes';

import invoiceAccountRemote from '../../api/invoiceAccountRemote';

import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';
import ForwarderInvoiceBalance from '../../models/ForwarderGhaInvoiceBalance';

import { receiveError } from './notificationAction';

function balanceSuccess(balance: ForwarderInvoiceBalance) {
  return {
    type: GET_FORWARDER_ACCOUNT_BALANCE,
    data: balance
  };
}

function receiveBalance(ghaId: number): (dispatch: Function) => void {

  return (dispatch: Function) => {

    invoiceAccountRemote.getAccountBalance(ghaId).then((resp: ApiResponse<ForwarderInvoiceBalance>) => {

      const balance: ForwarderInvoiceBalance | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;
    
      if (balance) {
        dispatch(balanceSuccess(balance));
      };
    
      if (error) {
        dispatch(receiveError(error));
      };
    });
  };
};

export {
  receiveBalance
};
